import {Component} from '@angular/core';
import {Toast} from 'ngx-toastr';

@Component({
  selector: 'app-toastr',
  standalone: true,
  imports: [],
  templateUrl: './toastr.component.html',
  styleUrl: './toastr.component.scss'
})
export class ToastrComponent extends Toast {

}
